import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HomeRedirectService } from '../../../@core/services/home-redirect.service';

@Component({
  selector: 'ngx-header-zus-button',
  templateUrl: './header-zus-button.component.html',
  styleUrls: ['./header-zus-button.component.scss']
})
export class HeaderZusButtonComponent {
  
  constructor(
    private router: Router,
    private homeRedirectService: HomeRedirectService
  ) {}

  navigateToHomeDg(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.homeRedirectService.getHomeRoute().subscribe(homeRoute => {
      this.router.navigate([homeRoute]);
    });
  }
}
